module.exports = __webpack_public_path__ + "static/media/poc_admin_inactive.924a90df.svg";